import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import Tooltip from '@components/Tooltip'
import Checkbox from '@components/Checkbox'
import Radio from '@components/Radio'
import ACL from '@components/ACL/ACL'
import { employeeApi } from '@atheneum/api'

class NotificationSettings extends Component {
  static propTypes = {
    userStore: PropTypes.object,
    notificationTypes: PropTypes.object,
    deliveryTypes: PropTypes.object
  }

  state = {
    generalNotifSetting: ''
  }

  handleSettingsOfAll = (value, settingsType) => {
    const { employee } = this.props.userStore.user
    const { notificationTypes } = this.props
    if (settingsType !== 'email') {
      this.setState({ generalNotifSetting: value })
    }
    Object.keys(notificationTypes).map(groupKey =>
      notificationTypes[groupKey].map(({ key }) =>
        settingsType === 'email'
          ? (employee.settings.notification[key].email = value)
          : (employee.settings.notification[key].deliveryType = value)
      )
    )
    employeeApi.updateSettings(employee.id, employee.settings)
  }

  handleMailFailure = value => {
    const { employee } = this.props.userStore.user
    employee.settings.MAIL_DELIVERY_FAILURE = value
    employeeApi.updateSettings(employee.id, employee.settings)
  }

  handleSettingsChange = (value, notifType, settingsType) => {
    const { employee } = this.props.userStore.user
    settingsType === 'email'
      ? (employee.settings.notification[notifType].email = value)
      : (employee.settings.notification[notifType].deliveryType = value)
    employeeApi.updateSettings(employee.id, employee.settings)
  }

  renderNotificationTypesHelper = (
    { key, name, permissions },
    notifSettings
  ) => {
    const { deliveryTypes } = this.props
    return (
      <ACL key={key} roles={permissions}>
        <div className='settings'>
          <div>{name}</div>
          <div className='notification-group__actions'>
            {deliveryTypes.map(type => (
              <div
                key={type.name}
                className='notification-group__actions--radio'
              >
                <Radio
                  checked={notifSettings[key].deliveryType === type.id}
                  onChange={() => this.handleSettingsChange(type.id, key)}
                />
                <div className='radio-group__item__label'>{type.name}</div>
              </div>
            ))}
            <Checkbox
              label='Receive an email'
              value={notifSettings[key].email}
              onChange={e => this.handleSettingsChange(e, key, 'email')}
            />
          </div>
        </div>
      </ACL>
    )
  }

  render () {
    const { userStore, notificationTypes, deliveryTypes } = this.props
    const notifSettings = userStore.user.employee.settings.notification
    if (notificationTypes && deliveryTypes) {
      return (
        <div className='m-t-xl'>
          <div className='notification-group'>
            <div className='settings'>
              <div>Notification</div>
              <div className='notification-group__actions'>
                {deliveryTypes.map(type => (
                  <div
                    key={type.name}
                    className='notification-group__actions--radio'
                  >
                    <Radio
                      checked={type.id === this.state.generalNotifSetting}
                      onChange={() => this.handleSettingsOfAll(type.id)}
                    />
                    <div className='radio-group__item__label'>{type.name}</div>
                  </div>
                ))}
                <Checkbox
                  label='Receive an email'
                  onChange={e => this.handleSettingsOfAll(e, 'email')}
                />
              </div>
            </div>
          </div>
          {Object.keys(notificationTypes).map(groupKey => (
            <div
              key={groupKey}
              className={`notification-group ${
                groupKey === 'general' ? 'm-t-xl' : ''
              }`}
            >
              {groupKey !== 'general' && <h2>{groupKey}</h2>}
              {notificationTypes[groupKey].map(notificationType =>
                this.renderNotificationTypesHelper(
                  notificationType,
                  notifSettings
                )
              )}
            </div>
          ))}
        </div>
      )
    } else {
      const { MAIL_DELIVERY_FAILURE } = userStore.user.employee.settings
      return (
        <div className='m-t-xl'>
          <div className='notification-group'>
            <div className='settings'>
              <div>Mail Delivery Failure</div>
              <Tooltip
                placement='bottom'
                tooltip='ATTENTION: Changing this setting will not affect emails that have not been delivered yet, but will only take affect on emails send after the settings change'
              >
                <div className='notification-group__actions'>
                  <Checkbox
                    label='Receive an email'
                    onChange={e => this.handleMailFailure(e)}
                    value={MAIL_DELIVERY_FAILURE}
                  />
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
      )
    }
  }
}

export default inject('userStore', 'growlStore')(observer(NotificationSettings))
